var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c(_vm.component,{tag:"component",attrs:{"offer":_vm.offer,"url":_vm.url,"clickable":_vm.clickable,"prices-tooltip-trigger":_vm.pricesTooltipTrigger,"top-deal":_vm.topDeal,"show-new-mobile-cards-info":_vm.showNewMobileCardsInfo},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }